// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './stores'
import App from './App'
import router from './router'
import * as filters from './filters'
import jquery from 'jquery'
import {
  Button,
  Popup,
  Notify,
  Toast,
  Tab,
  Tabs,
  List,
  Loading,
  Collapse,
  Dialog,
  CollapseItem,
  ImagePreview,
  Icon
} from 'vant'
import {
  Scrollbar
} from 'element-ui'
import '@/permission' // permission control
import gallery from 'img-vuer'
import Flex from '@/components/Flex'
import WaterFall from '@/components/WaterFallDefault'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import hls from 'videojs-contrib-hls'

/* eslint-disable */

const dsbridge = require('dsbridge')

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']
// 注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

// 注册Vant组件
Vue.use(Button)
Vue.use(Popup)
Vue.use(Tab).use(Tabs)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Notify)
Vue.use(Collapse).use(CollapseItem)
Vue.use(ImagePreview)
Vue.use(Scrollbar)
Vue.component('Flex', Flex)
Vue.component('WaterFall', WaterFall)
Vue.use(Icon)

// Vue.prototype.$notify = Notify
Vue.prototype.$toast = Toast
Vue.prototype.$imagePreview = ImagePreview
Vue.prototype.$ = jquery
Vue.prototype.$video = Video


Vue.use(hls)
Vue.use(gallery)

/* eslint-disable no-new */
const vRouter = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: {
    eventHub: new Vue() // global event bus
  },
  template: '<App/>'
})

Vue.use({
  vRouter
})
